<template>
    <section class="product-item position-relative pb-5">

        <!-- GŁÓWNY NAGŁÓWEK EKRANU (Tytuł modyfikacji) -->
        <div class="row mb-3">
            <div class="col-12">
                <h4 v-if="$attrs.mode === 'new'" class="text-primary">{{ $t('createNewTitle') }}</h4>
                <h4 v-else class="card-title text-primary m-0">
                    {{ $t('editEntry') }} {{itemName}} <b-badge variant="light" class="text-muted ml-2">ID: {{item.id}}</b-badge>
                </h4>
            </div>
        </div>

        <!-- KONTENER KART Z ZAKŁADKAMI PIONOWYMI -->
        <div class="card shadow-sm border-0 mb-5">
            <b-tabs pills card vertical nav-wrapper-class="w-15 bg-light rounded-left border-right" content-class="mt-0" active-nav-item-class="bg-primary font-weight-bold shadow-sm">

                <!-- ZAKŁADKA 1: PODSTAWOWE -->
                <b-tab :title="'📍 ' + $t('forms.basicInfo')" active>
                    <div class="p-3">
                        <h5 class="border-bottom pb-2 mb-4 text-secondary">{{ $t('forms.basicInfo') }}</h5>

                        <div class="row">
                            <div class="col-lg-2">
                                <b-form-group :label="$t('forms.category')" label-for="category-input">
                                    <b-form-select v-model="item.category.id" :options="categories" value-field="id" text-field="name" :state="categoryState"/>
                                </b-form-group>
                            </div>
                            <div class="col-lg-2">
                                <b-form-group :label="$t('forms.order')" label-for="order-input">
                                    <b-form-input type="number" id="order-input" :placeholder="$t('forms.order')" v-model="item.itemOrder" :state="orderState" min="1"/>
                                </b-form-group>
                            </div>
                            <div class="col-lg-4">
                                <b-form-group label="URL" label-for="url-input">
                                    <b-form-input type="text" id="url-input" placeholder="URL" v-model="item.url" :state="urlState"/>
                                </b-form-group>
                            </div>
                            <div class="col-lg-4 d-flex align-items-center">
                                <b-form-group :label="$t('forms.buyPossibility')" class="mb-0">
                                    <b-form-checkbox v-model="item.canBuy" name="check-button" switch>
                                        <p v-text="item.canBuy ? $t('forms.yes') : $t('forms.no')" style="margin-top: 4px;" class="pl-2" />
                                    </b-form-checkbox>
                                </b-form-group>
                            </div>
                        </div>

                        <b-form-group :label="$t('forms.name')" class="mb-4 mt-3">
                            <b-input-group size="md" class="mb-2">
                                <b-input-group-prepend is-text class="bg-light font-weight-bold" style="width: 55px; justify-content: center;">{{ Const.LANG.toUpperCase() }}</b-input-group-prepend>
                                <b-form-input type="text" :placeholder="$t('forms.name') + ' (' + Const.LANG.toUpperCase() + ')'" v-model="item.name" :state="nameState"/>
                            </b-input-group>
                            <b-input-group size="md">
                                <b-input-group-prepend is-text class="bg-light font-weight-bold" style="width: 55px; justify-content: center;">EN</b-input-group-prepend>
                                <b-form-input type="text" :placeholder="$t('forms.name') + ' (EN)'" v-model="item.nameEn" :state="nameEnState"/>
                            </b-input-group>
                        </b-form-group>

                        <div class="bg-light p-3 rounded border">
                            <b-form-group :label="$t('forms.tags')" class="mb-0">
                                <b-form-tags id="tags-input" v-model="newTags" no-outer-focus class="mb-2 border-0 bg-transparent p-0">
                                    <template v-slot="{ tags, disabled, addTag, removeTag }">
                                        <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2 w-100">
                                            <li v-for="tag in tags" :key="tag" class="list-inline-item mb-1">
                                                <b-form-tag
                                                    @remove="removeTag(tag)" :title="getTagLabel(tag)" :disabled="disabled"
                                                    :class="[getTagClass(tag), 'text-uppercase font-weight-bold px-2 py-1']"
                                                    style="letter-spacing: 0.5px; border: none; font-size: 0.75rem;">
                                                    {{ getTagLabel(tag) }}
                                                </b-form-tag>
                                            </li>
                                        </ul>
                                        <b-dropdown size="sm" variant="primary" block menu-class="w-100">
                                            <template #button-content>{{ $t('forms.selectProductTags') }}</template>
                                            <b-dropdown-item-button v-for="option in availableTags.filter(t => !tags.includes(t.value))" :key="option.value" @click="addTag(option.value)">
                                                <span class="d-inline-block rounded-circle mr-2" :class="option.customClass" style="width: 12px; height: 12px;"></span>{{ option.text }}
                                            </b-dropdown-item-button>
                                        </b-dropdown>
                                    </template>
                                </b-form-tags>
                            </b-form-group>
                        </div>

                    </div>
                </b-tab>

                <!-- ZAKŁADKA 2: SEO I OPISY -->
                <b-tab :title="'📝 ' + $t('forms.descriptionsAndSEO')">
                    <div class="p-3">
                        <h5 class="border-bottom pb-2 mb-4 text-secondary">{{ $t('forms.descriptionsAndSEO') }}</h5>

                        <b-form-group :label="$t('forms.headTitle')" class="mb-4">
                            <b-input-group size="sm" class="mb-2">
                                <b-input-group-prepend is-text class="bg-light" style="width: 55px; justify-content: center;">{{ Const.LANG.toUpperCase() }}</b-input-group-prepend>
                                <b-form-input type="text" :placeholder="$t('forms.headTitle') + ' (' + Const.LANG.toUpperCase() + ')'" v-model="item.title" :state="titleState"/>
                            </b-input-group>
                            <b-input-group size="sm">
                                <b-input-group-prepend is-text class="bg-light" style="width: 55px; justify-content: center;">EN</b-input-group-prepend>
                                <b-form-input type="text" :placeholder="$t('forms.headTitle') + ' (EN)'" v-model="item.titleEn" :state="titleEnState"/>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group :label="$t('forms.headDescription')" class="mb-4">
                            <b-input-group size="sm" class="mb-2">
                                <b-input-group-prepend is-text class="bg-light" style="width: 55px; justify-content: center;">{{ Const.LANG.toUpperCase() }}</b-input-group-prepend>
                                <b-form-input type="text" :placeholder="$t('forms.headDescription') + ' (' + Const.LANG.toUpperCase() + ')'" v-model="item.description" :state="descriptionState"/>
                            </b-input-group>
                            <b-input-group size="sm">
                                <b-input-group-prepend is-text class="bg-light" style="width: 55px; justify-content: center;">EN</b-input-group-prepend>
                                <b-form-input type="text" :placeholder="$t('forms.headDescription') + ' (EN)'" v-model="item.descriptionEn" :state="descriptionEnState"/>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group :label="$t('forms.description')" class="mb-4 mt-5 border-top pt-4">
                            <b-tabs>
                                <b-tab :title="Const.LANG.toUpperCase()" active>
                                    <b-form-textarea v-model="item.summary" rows="8" :state="summaryState"></b-form-textarea>
                                </b-tab>
                                <b-tab title="EN">
                                    <b-form-textarea v-model="item.summaryEn" rows="8" :state="summaryEnState"></b-form-textarea>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </div>
                </b-tab>

                <!-- ZAKŁADKA 3: SPECYFIKACJA (TABELE) -->
                <b-tab :title="'⚙️ ' + $t('forms.specification')">
                    <div class="p-3">
                        <h5 class="border-bottom pb-2 mb-4 text-secondary">{{ $t('forms.specification') }}</h5>

                        <b-card no-body class="mb-4 shadow-sm">
                            <b-tabs card>
                                <b-tab :title="$t('forms.productFeatures')" active>
                                    <b-table responsive hover :items="newFeatures" :fields="featuresFields" small class="m-0">
                                        <template v-slot:cell(name)="row"><b-form-input :state="featureNameInputValidation(row.index)" v-model="row.item.name"/></template>
                                        <template v-slot:cell(nameEn)="row"><b-form-input :state="featureNameEnInputValidation(row.index)" v-model="row.item.nameEn"/></template>
                                        <template v-slot:cell(delete)="row"><b-button size="sm" variant="outline-danger" @click="deleteFeatureRow(row.index)">&times;</b-button></template>
                                    </b-table>
                                    <div class="p-2 bg-light text-right border-top"><b-button size="sm" variant="primary" @click="addFeatureRow">+ {{ $t('forms.add') }}</b-button></div>
                                </b-tab>

                                <b-tab :title="$t('forms.attributes')">
                                    <b-table responsive hover :items="newAttributes" :fields="attributesFields" small class="m-0">
                                        <template v-slot:cell(key)="row"><b-form-input v-model="row.item.key" :placeholder="$t('forms.attributeKeyPrompt')"/></template>
                                        <template v-slot:cell(value)="row"><b-form-input v-model="row.item.value" :placeholder="$t('forms.attributeValuePrompt')"/></template>
                                        <template v-slot:cell(keyEn)="row"><b-form-input v-model="row.item.keyEn" :placeholder="$t('forms.attributeKeyPromptEn')"/></template>
                                        <template v-slot:cell(valueEn)="row"><b-form-input v-model="row.item.valueEn" :placeholder="$t('forms.attributeValuePromptEn')"/></template>
                                        <template v-slot:cell(delete)="row"><b-button size="sm" variant="outline-danger" @click="deleteAttributeRow(row.index)">&times;</b-button></template>
                                    </b-table>
                                    <div class="p-2 bg-light text-right border-top"><b-button size="sm" variant="primary" @click="addAttributeRow">+ {{ $t('forms.add') }}</b-button></div>
                                </b-tab>

                                <b-tab :title="$t('forms.standardEquipment')">
                                    <b-table responsive hover :items="newEquipment" :fields="equipmentFields" small class="m-0">
                                        <template v-slot:cell(name)="row"><b-form-input v-model="row.item.name" :placeholder="$t('forms.equipmentPrompt')"/></template>
                                        <template v-slot:cell(nameEn)="row"><b-form-input v-model="row.item.nameEn" :placeholder="$t('forms.equipmentPromptEn')"/></template>
                                        <template v-slot:cell(delete)="row"><b-button size="sm" variant="outline-danger" @click="deleteEquipmentRow(row.index)">&times;</b-button></template>
                                    </b-table>
                                    <div class="p-2 bg-light text-right border-top"><b-button size="sm" variant="primary" @click="addEquipmentRow">+ {{ $t('forms.add') }}</b-button></div>
                                </b-tab>

                                <b-tab :title="$t('forms.additionalEquipment')">
                                    <b-table responsive hover :items="newAdditionalEquipment" :fields="additionalEquipmentFields" small class="m-0">
                                        <template v-slot:cell(name)="row"><b-form-input v-model="row.item.name" :placeholder="$t('forms.equipmentPrompt')"/></template>
                                        <template v-slot:cell(nameEn)="row"><b-form-input v-model="row.item.nameEn" :placeholder="$t('forms.equipmentPromptEn')"/></template>
                                        <template v-slot:cell(delete)="row"><b-button size="sm" variant="outline-danger" @click="deleteAdditionalEquipmentRow(row.index)">&times;</b-button></template>
                                    </b-table>
                                    <div class="p-2 bg-light text-right border-top"><b-button size="sm" variant="primary" @click="addAdditionalEquipmentRow">+ {{ $t('forms.add') }}</b-button></div>
                                </b-tab>

                                <b-tab :title="$t('forms.application')">
                                    <b-table responsive hover :items="newApplications" :fields="applicationsFields" small class="m-0">
                                        <template v-slot:cell(name)="row"><b-form-input v-model="row.item.name" :placeholder="$t('forms.applicationPrompt')"/></template>
                                        <template v-slot:cell(nameEn)="row"><b-form-input v-model="row.item.nameEn" :placeholder="$t('forms.applicationPromptEn')"/></template>
                                        <template v-slot:cell(delete)="row"><b-button size="sm" variant="outline-danger" @click="deleteApplicationRow(row.index)">&times;</b-button></template>
                                    </b-table>
                                    <div class="p-2 bg-light text-right border-top"><b-button size="sm" variant="primary" @click="addApplicationRow">+ {{ $t('forms.add') }}</b-button></div>
                                </b-tab>
                            </b-tabs>
                        </b-card>

                    </div>
                </b-tab>

                <!-- ZAKŁADKA 4: ZALETY I FAQ -->
                <b-tab :title="'❓ ' + $t('forms.advantagesAndFaq')">
                    <div class="p-3">
                        <h5 class="border-bottom pb-2 mb-4 text-secondary">{{ $t('forms.productAdvantages') }}</h5>
                        <div v-for="(adv, index) in newAdvantages" :key="'adv'+index" class="border p-3 mb-3 bg-light rounded shadow-sm">
                            <div class="d-flex justify-content-between mb-2">
                                <strong>#{{ index + 1 }} {{ $t('forms.advantage') }}</strong>
                                <b-button variant="link" class="text-danger p-0" @click="deleteAdvantageRow(index)">&times; {{ $t('forms.delete') }}</b-button>
                            </div>
                            <div class="row">
                                <div class="col-md-6"><b-form-textarea v-model="adv.name" rows="5" :placeholder="$t('forms.advantagePrompt')"></b-form-textarea></div>
                                <div class="col-md-6"><b-form-textarea v-model="adv.nameEn" rows="5" :placeholder="$t('forms.advantagePromptEn')"></b-form-textarea></div>
                            </div>
                        </div>
                        <div v-if="newAdvantages.length === 0" class="text-muted small mb-3">{{ $t('forms.noAdvantages') }}</div>
                        <b-button variant="outline-primary" size="sm" class="mb-5" @click="addAdvantageRow">+ {{ $t('forms.add') }}</b-button>

                        <h5 class="border-bottom pb-2 mb-4 text-secondary mt-4">{{ $t('forms.faq') }}</h5>
                        <div v-for="(faqItem, index) in newFaq" :key="'faq'+index" class="border p-3 mb-3 bg-light rounded shadow-sm">
                            <div class="d-flex justify-content-between mb-2">
                                <strong>#{{ index + 1 }} Q&A</strong>
                                <b-button variant="link" class="text-danger p-0" @click="deleteFaqRow(index)">&times; {{ $t('forms.delete') }}</b-button>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-6"><b-form-input v-model="faqItem.question" :placeholder="$t('forms.question') + ' (' + Const.LANG.toUpperCase() + ')'"></b-form-input></div>
                                <div class="col-md-6"><b-form-input v-model="faqItem.questionEn" :placeholder="$t('forms.question') + ' (EN)'"></b-form-input></div>
                            </div>
                            <div class="row">
                                <div class="col-md-6"><b-form-textarea v-model="faqItem.answer" rows="5" :placeholder="$t('forms.answer') + ' (' + Const.LANG.toUpperCase() + ')'"></b-form-textarea></div>
                                <div class="col-md-6"><b-form-textarea v-model="faqItem.answerEn" rows="5" :placeholder="$t('forms.answer') + ' (EN)'"></b-form-textarea></div>
                            </div>
                        </div>
                        <div v-if="newFaq.length === 0" class="text-muted small mb-3">{{ $t('forms.noFaq') }}</div>
                        <b-button variant="outline-primary" size="sm" @click="addFaqRow">+ {{ $t('forms.add') }}</b-button>
                    </div>
                </b-tab>

                <!-- ZAKŁADKA 5: USŁUGI I CENNIK -->
                <b-tab :title="'💰 ' + $t('forms.pricingAndServices')">
                    <div class="p-3">
                        <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-4">
                            <h5 class="text-secondary m-0">{{ $t('forms.productVases') }}</h5>
                            <b-button variant="primary" size="sm" @click="addAdditionalServiceRow">+ {{ $t('forms.add') }}</b-button>
                        </div>

                        <b-table v-if="newAS && newAS.length > 0" responsive hover :items="newAS" :fields="asFields" small class="mt-4">
                            <template v-slot:cell(name)="row"><b-form-input :state="nameInputValidation(row.index)" v-model="row.item.name"/></template>
                            <template v-slot:cell(nameEn)="row"><b-form-input :state="nameEnInputValidation(row.index)" v-model="row.item.nameEn"/></template>
                            <template v-slot:cell(netPrice)="row"><b-form-input :state="netPriceValidation(row.index)" v-model="row.item.netPrice" type="number"/></template>
                            <template v-slot:cell(serviceType)="row"><b-form-select v-model="row.item.serviceType" :options="options"/></template>
                            <template v-slot:cell(serviceOrder)="row"><b-form-input :state="serviceOrderValidation(row.index)" v-model="row.item.serviceOrder" type="number"/></template>
                            <template v-slot:cell(delete)="row"><b-button variant="outline-danger" size="sm" @click="deleteAdditionalServiceRow(row.index)">&times;</b-button></template>
                        </b-table>
                        <div v-else class="text-center text-muted p-5 bg-light rounded border border-dashed">
                            {{ $t('forms.productVasesEmpty') }}
                        </div>
                    </div>
                </b-tab>

                <!-- ZAKŁADKA 6: MEDIA I ZDJĘCIA -->
                <b-tab :title="'🖼️ ' + $t('forms.media')">
                    <div class="p-3">
                        <h5 class="border-bottom pb-2 mb-4 text-secondary">{{ $t('forms.media') }}</h5>

                        <div class="row">
                            <div class="col-lg-3">
                                <b-form-group :label="$t('forms.thumbnail')" label-for="thumbnail-input" class="bg-light p-3 rounded border text-center">
                                    <div class="d-flex justify-content-center">
                                        <div v-if="item.thumbnail && item.thumbnail.id" class="position-relative border rounded p-2 bg-white shadow-sm image-tile" style="border: 2px solid #28a745 !important;">
                                            <img :src="mediaHostname + item.thumbnail.filename" class="img-fluid mb-2" style="max-height: 80px; object-fit: contain;">
                                            <b-button size="sm" variant="danger" class="position-absolute d-flex justify-content-center align-items-center p-0" style="top: -8px; right: -8px; width: 24px; height: 24px; border-radius: 50%; z-index: 10;" @click.stop="removeThumbnail">&times;</b-button>
                                        </div>
                                        <div v-else class="rounded p-2 text-center image-tile add-image-tile" :class="{'border-danger': !thumbnailState, 'text-danger': !thumbnailState}" @click="openImagePicker('thumbnail-input')" :title="$t('forms.selectThumbnail')">
                                            <span class="add-icon">+</span>
                                        </div>
                                    </div>
                                    <div class="text-danger small mt-2" v-if="!thumbnailState">{{ $t('forms.thumbnailRequired') }}</div>
                                </b-form-group>
                            </div>

                            <div class="col-lg-3">
                                <b-form-group :label="$t('forms.image360')" label-for="image360-input" class="bg-light p-3 rounded border text-center">
                                    <div class="d-flex justify-content-center">
                                        <div v-if="item.image360 && item.image360.id" class="position-relative border rounded p-2 bg-white shadow-sm image-tile">
                                            <img :src="mediaHostname + item.image360.filename" class="img-fluid mb-2" style="max-height: 80px; object-fit: contain;">
                                            <b-button size="sm" variant="danger" class="position-absolute d-flex justify-content-center align-items-center p-0" style="top: -8px; right: -8px; width: 24px; height: 24px; border-radius: 50%; z-index: 10;" @click.stop="removeImage360">&times;</b-button>
                                        </div>
                                        <div v-else class="rounded p-2 text-center image-tile add-image-tile text-muted" @click="openImagePicker('image360-input')" :title="$t('forms.selectImage360')">
                                            <span class="add-icon">+</span>
                                        </div>
                                    </div>
                                </b-form-group>
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-lg-12">
                                <b-form-group :label="$t('forms.productGallery')" label-for="images-input">
                                    <div class="d-flex flex-wrap p-3 bg-light rounded border" style="gap: 12px; min-height: 175px;">
                                        <div v-for="(img, index) in item.images" :key="'img' + index" class="position-relative border rounded p-2 text-center bg-white shadow-sm image-tile">
                                            <img :src="mediaHostname + img.filename" class="img-fluid mb-2" style="max-height: 80px; object-fit: contain;">
                                            <small class="text-muted text-truncate w-100 d-inline-block" :title="img.filename.substr(8)">{{ img.filename.substr(8) }}</small>
                                            <b-button size="sm" variant="danger" class="position-absolute d-flex justify-content-center align-items-center p-0" style="top: -8px; right: -8px; width: 24px; height: 24px; border-radius: 50%;" @click="removeImage(index)">&times;</b-button>
                                        </div>
                                        <div class="rounded p-2 text-center image-tile add-image-tile text-muted" @click="openImagePicker('images-input')" :title="$t('forms.addProductImage')">
                                            <span class="add-icon">+</span>
                                        </div>
                                    </div>
                                    <div class="text-danger small mt-1" v-if="!imageState">{{ $t('forms.productImageRequired') }}</div>
                                </b-form-group>
                            </div>
                        </div>

                        <b-form-group :label="$t('forms.productDatasheet')" label-for="datasheet-input" class="pt-4 mt-4 border-top">
                            <div class="d-flex align-items-center">
                                <b-button id="datasheet-input" :variant="item.datasheet && item.datasheet.id ? 'success' : 'outline-primary'" @click="openFilePicker('datasheet-input')" class="mr-3">
                                    <b-icon icon="file-earmark-pdf"></b-icon> {{item.datasheet && item.datasheet.id ? $t('forms.change') : $t('forms.select')}}
                                </b-button>
                                <b-form-input type="text" id="datasheet-input" placeholder="-" :value="item.datasheet && item.datasheet.filename ? item.datasheet.filename.substr(7) : ''" disabled style="max-width: 400px;"/>
                            </div>
                        </b-form-group>
                    </div>
                </b-tab>

            </b-tabs>
        </div>

        <!-- PŁYWAJĄCY PASEK ZAPISU (STICKY FOOTER) -->
        <div class="fixed-bottom bg-white border-top p-3 shadow-top-lg d-flex justify-content-between align-items-center" style="z-index: 1020; left: 255px;">
            <div>
                <span class="text-danger small ml-3" v-if="validated">{{ $t('forms.fillRequiredFields') }}</span>
                <span class="text-success  small ml-3" v-if="!validated">{{ $t('forms.statusOk').toUpperCase() }}</span>
            </div>
            <div>
                <b-button variant="light" v-on:click="cancel" class="mr-2">{{ $t('forms.cancel') }}</b-button>
                <b-button v-if="$attrs.mode === 'edit'" variant="outline-danger" class="mr-3" v-b-modal.confirm-delete>{{ $t('forms.delete') }}</b-button>
                <b-button variant="success" size="lg" @click="saveItem" :disabled="validated" class="px-5"><b-icon icon="check2-circle"></b-icon> {{ $t('forms.save') }}</b-button>
            </div>
        </div>

        <!-- MODALE (Zostawiono Twoje oryginalne Modale, tu nic nie trzeba psuć) -->
        <confirm-delete-modal extended @confirm="deleteItem"/>

        <b-modal id="image-picker" :title="$t('forms.imagePickerTitle')" size="xl" header-bg-variant="primary" header-text-variant="light" :okTitle="$t('forms.close')" ok-only @hidden="resetImagePicker">
            <div class="d-flex justify-content-between align-items-center mb-3 pb-3 border-bottom">
                <b-form-group class="mb-0 w-50">
                    <b-form-input v-model="imageSearchQuery" type="search" :placeholder="$t('forms.search')" size="sm"></b-form-input>
                </b-form-group>
                <span class="text-muted small">{{ $t('forms.imagePicker.found', {count: filteredImages.length }) }}</span>
            </div>

            <div class="image-grid-container mb-3" v-if="paginatedImages.length > 0">
                <div v-for="image in paginatedImages" :key="image.id" :id="'image-wrapper-' + image.id"
                     class="image-picker-tile border rounded" @click="pasteImage(image.id)">

                    <div class="image-thumbnail-wrapper">
                        <img :id="image.id" :src="mediaHostname + image.filename" :alt="image.alt" class="img-fluid">
                    </div>

                    <div class="image-tile-footer bg-light text-truncate small px-2 py-1 text-center" :title="image.filename.substr(8)">
                        {{ image.filename.substr(8) }}
                    </div>

                    <b-popover :target="'image-wrapper-' + image.id" triggers="hover" placement="top" custom-class="shadow-sm">
                        <div class="text-center">
                            <strong class="d-block mb-1">{{image.width}} x {{image.height}} px</strong>
                            <span class="text-muted text-break" style="font-size: 0.8rem;">{{image.filename.substr(8)}}</span>
                        </div>
                    </b-popover>
                </div>
            </div>

            <div v-else class="text-center py-5 text-muted">
                <span style="font-size: 2rem;">😕</span><br>
                {{ $t('forms.imagePicker.noResults') }}
            </div>

            <div class="d-flex justify-content-center border-top pt-3" v-if="filteredImages.length > perPage">
                <b-pagination v-model="currentPage" :total-rows="filteredImages.length" :per-page="perPage"></b-pagination>
            </div>
        </b-modal>

        <b-modal id="file-picker" :title="$t('forms.filePickerTitle')" size="xl" header-bg-variant="primary" header-text-variant="light" :okTitle="$t('forms.close')" ok-only>
            <b-table striped hover small :items="files" :fields="fileFields" @row-clicked="pasteFile" class="clickable"></b-table>
        </b-modal>
    </section>
</template>

<script>
    import axios from 'axios'
    import {Const} from '../../../config'
    import moment from "moment/moment";
    import ConfirmDeleteModal from '@/components/ConfirmDeleteModal'

    export default {
        name: 'ProductItem',
        components: {
            ConfirmDeleteModal
        },
        computed: {
            Const() {
                return Const
            },
            nameState() {
                return !(!this.item.name || String(this.item.name).trim().length === 0);
            },
            nameEnState() {
                return !(!this.item.nameEn || String(this.item.nameEn).trim().length === 0);
            },
            titleState() {
                return !(!this.item.title || String(this.item.title).trim().length === 0);
            },
            titleEnState() {
                return !(!this.item.titleEn || String(this.item.titleEn).trim().length === 0);
            },
            descriptionState() {
                return !(!this.item.description || String(this.item.description).trim().length === 0);
            },
            descriptionEnState() {
                return !(!this.item.descriptionEn || String(this.item.descriptionEn).trim().length === 0);
            },
            summaryState() {
                return !(!this.item.summary || String(this.item.summary).trim().length === 0);
            },
            summaryEnState() {
                return !(!this.item.summaryEn || String(this.item.summaryEn).trim().length === 0);
            },
            urlState() {
                if (!this.item.url || String(this.item.url).trim().length === 0) return false;
                let urlStr = String(this.item.url).trim();
                return urlStr.startsWith('/') && urlStr.split('/').length === 2;
            },
            orderState() {
                return this.item.itemOrder !== null && this.item.itemOrder !== '' && Number(this.item.itemOrder) > 0;
            },
            categoryState() {
                return !!(this.item.category && this.item.category.id && Number(this.item.category.id) > 0);
            },
            thumbnailState() {
                return !!(this.item.thumbnail && this.item.thumbnail.id && Number(this.item.thumbnail.id) > 0);
            },
            imageState() {
                return !!(this.item.images && Array.isArray(this.item.images) && this.item.images.length > 0);
            },
            validateAdditionalServices() {
                if (!this.newAS || !Array.isArray(this.newAS)) return true;
                for (let i = 0; i < this.newAS.length; i++) {
                    let as = this.newAS[i];
                    if (!as.name || String(as.name).trim().length < 5) return false;

                    if (as.netPrice === null || as.netPrice === '' || isNaN(as.netPrice) || Number(as.netPrice) < 0) return false;
                    if (as.serviceOrder === null || as.serviceOrder === '' || isNaN(as.serviceOrder) || Number(as.serviceOrder) <= 0) return false;
                }
                return true;
            },
            validateFeatures() {
                return !!(this.newFeatures && Array.isArray(this.newFeatures) && this.newFeatures.length > 0);
            },
            validated() {
                return !this.nameState || !this.nameEnState || !this.titleState || !this.titleEnState ||
                    !this.descriptionState || !this.descriptionEnState || !this.urlState || !this.categoryState ||
                    !this.orderState || !this.thumbnailState || !this.imageState || !this.validateAdditionalServices ||
                    !this.validateFeatures
            },
            filteredImages() {
                if (!this.imageSearchQuery) {
                    return this.images || [];
                }
                let query = this.imageSearchQuery.toLowerCase();
                return (this.images || []).filter(img => {
                    return img.filename && img.filename.toLowerCase().includes(query);
                });
            },
            paginatedImages() {
                const start = (this.currentPage - 1) * this.perPage;
                const end = start + this.perPage;
                return this.filteredImages.slice(start, end);
            }
        },
        watch: {
            imageSearchQuery() {
                this.currentPage = 1;
            }
        },
        data() {
            return {
                lang: Const.LANG,
                mediaHostname: Const.MEDIA_HOST,
                categories: [],
                images: [],
                files: [],
                item: {},
                itemName: '',
                itemFeatures: [],
                imagePickerContext: '',
                filePickerContext: '',
                newTags: [],
                availableTags: [
                    { value: 'RECOMMENDED', text: this.$t('forms.tag.recommended'), customClass: 'tag-custom-green' },
                    { value: 'NEW', text: this.$t('forms.tag.new'), customClass: 'tag-custom-pink' },
                    { value: 'PROMOTION', text: this.$t('forms.tag.promotion'), customClass: 'tag-custom-orange' },
                    { value: 'SUPER_PRICE', text: this.$t('forms.tag.superPrice'), customClass: 'tag-custom-purple' }
                ],
                newEquipment: [],
                newAdditionalEquipment: [],
                newAttributes: [],
                equipmentFields: [
                    { key: 'name', label: this.$t('forms.name') + ' (' + Const.LANG.toUpperCase() + ')' },
                    { key: 'nameEn', label: this.$t('forms.name') + ' (EN)' },
                    { key: 'delete', label: '', thStyle: 'width: 80px;' }
                ],
                additionalEquipmentFields: [
                    { key: 'name', label: this.$t('forms.name') + ' (' + Const.LANG.toUpperCase() + ')' },
                    { key: 'nameEn', label: this.$t('forms.name') + ' (EN)' },
                    { key: 'delete', label: '', thStyle: 'width: 80px;' }
                ],
                attributesFields: [
                    { key: 'key', label: this.$t('forms.key') + ' (' + Const.LANG.toUpperCase() + ')' },
                    { key: 'value', label: this.$t('forms.attributeValue') + ' (' + Const.LANG.toUpperCase() + ')' },
                    { key: 'keyEn', label: this.$t('forms.key') + ' (EN)' },
                    { key: 'valueEn', label: this.$t('forms.attributeValue') + ' (EN)' },
                    { key: 'delete', label: '', thStyle: 'width: 80px;' }
                ],
                featuresFields: [
                    { key: 'name', label: this.$t('forms.name') + ' (' + Const.LANG.toUpperCase() + ')' },
                    { key: 'nameEn', label: this.$t('forms.name') + ' (EN)' },
                    { key: 'delete', label: '', thStyle: 'width: 80px;' }
                ],
                asFields: [
                    { key: 'name', label: this.$t('forms.name') + ' (' + Const.LANG.toUpperCase() + ')' },
                    { key: 'nameEn', label: this.$t('forms.name') + ' (EN)' },
                    { key: 'serviceType', label: this.$t('forms.feeType'), thStyle: 'width: 150px;' },
                    { key: 'serviceOrder', label: this.$t('forms.order'), thStyle: 'width: 150px;' },
                    { key: 'netPrice', label: this.$t('forms.netPrice'), thStyle: 'width: 150px;' },
                    { key: 'delete', label: '', thStyle: 'width: 80px;' }
                ],
                newFeatures: [],
                newAS: [],
                options: [
                    { value: "ONE_TIME_FEE", text: this.$t('forms.feeTypeOneTime') },
                    { value: "RECURRING_FEE", text: this.$t('forms.feeTypeRecurring') },
                ],
                fileFields: [
                    { key: 'id', label: 'ID', sortable: true },
                    { key: 'filename', label: this.$t('forms.name'), sortable: true, formatter: value => this.trimEllip(value.substr(7), 120) },
                    { key: 'uploadDate', label: this.$t('forms.created'), sortable: true, formatter: value => moment(value).format('DD.MM.YYYY, HH:mm') }
                ],
                newApplications: [],
                newAdvantages: [],
                newFaq: [],
                applicationsFields: [
                    { key: 'name', label: this.$t('forms.application') + ' (' + Const.LANG.toUpperCase() + ')' },
                    { key: 'nameEn', label: this.$t('forms.application') + ' (EN)' },
                    { key: 'delete', label: '', thStyle: 'width: 80px;' }
                ],
                imageSearchQuery: '',
                currentPage: 1,
                perPage: 28,
            }
        },
        mounted() {
            axios.get(Const.API_HOST + '/admin/productCategories')
                .then(function (response) { return response.data })
                // eslint-disable-next-line no-console
                .catch(function (error) { console.error(error) })
                .then(body => { this.categories = body })

            if (this.$attrs.mode === Const.MODE_EDIT) {
                axios.get(Const.API_HOST + '/admin/productItem/get', { params: { 'id': this.$route.params.id } })
                    .then(function (response) { return response.data })
                    // eslint-disable-next-line no-console
                    .catch(function (error) { console.error(error) })
                    .then(body => {
                        this.item = body
                        this.itemName = JSON.parse(JSON.stringify(this.item.name))

                        if (!this.item.images) {
                            this.$set(this.item, 'images', []);
                        }

                        if (this.item.features == null) { this.newFeatures = [] }
                        else { this.newFeatures = this.item.features }

                        if (this.item.additionalServices == null) { this.newAS = [] }
                        else {
                            this.item.additionalServices.forEach(function (as) {
                                if (as.netPrice === undefined || as.netPrice === null) as.netPrice = 0
                                as.netPrice = as.netPrice.toFixed(2)
                            })
                            this.newAS = this.item.additionalServices
                        }

                        this.newTags = this.item.tags || [];

                        this.newEquipment = [];
                        let eqPl = this.item.equipment || [];
                        let eqEn = this.item.equipmentEn || [];
                        let maxEq = Math.max(eqPl.length, eqEn.length);
                        for (let i = 0; i < maxEq; i++) {
                            this.newEquipment.push({
                                name: eqPl[i] || '',
                                nameEn: eqEn[i] || ''
                            });
                        }

                        this.newAdditionalEquipment = [];
                        let aEqPl = this.item.additionalEquipment || [];
                        let aEqEn = this.item.additionalEquipmentEn || [];
                        let maxAEq = Math.max(aEqPl.length, aEqEn.length);
                        for (let i = 0; i < maxAEq; i++) {
                            this.newAdditionalEquipment.push({
                                name: aEqPl[i] || '',
                                nameEn: aEqEn[i] || ''
                            });
                        }

                        this.newAttributes = [];
                        let attrPl = this.item.attributes || {};
                        let attrEn = this.item.attributesEn || {};
                        let plKeys = Object.keys(attrPl);
                        let enKeys = Object.keys(attrEn);
                        let maxAttr = Math.max(plKeys.length, enKeys.length);
                        for (let i = 0; i < maxAttr; i++) {
                            this.newAttributes.push({
                                key: plKeys[i] || '',
                                value: attrPl[plKeys[i]] || '',
                                keyEn: enKeys[i] || '',
                                valueEn: attrEn[enKeys[i]] || ''
                            });
                        }

                        this.newApplications = [];
                        let appPl = this.item.applications || [];
                        let appEn = this.item.applicationsEn || [];
                        let maxApp = Math.max(appPl.length, appEn.length);
                        for (let i = 0; i < maxApp; i++) {
                            this.newApplications.push({ name: appPl[i] || '', nameEn: appEn[i] || '' });
                        }

                        this.newAdvantages = [];
                        let advPl = this.item.advantages || [];
                        let advEn = this.item.advantagesEn || [];
                        let maxAdv = Math.max(advPl.length, advEn.length);
                        for (let i = 0; i < maxAdv; i++) {
                            this.newAdvantages.push({ name: advPl[i] || '', nameEn: advEn[i] || '' });
                        }

                        this.newFaq = [];
                        let faqPl = this.item.faq || {};
                        let faqEn = this.item.faqEn || {};
                        let faqPlKeys = Object.keys(faqPl);
                        let faqEnKeys = Object.keys(faqEn);
                        let maxFaq = Math.max(faqPlKeys.length, faqEnKeys.length);
                        for (let i = 0; i < maxFaq; i++) {
                            this.newFaq.push({
                                question: faqPlKeys[i] || '',
                                answer: faqPl[faqPlKeys[i]] || '',
                                questionEn: faqEnKeys[i] || '',
                                answerEn: faqEn[faqEnKeys[i]] || ''
                            });
                        }
                    })
            } else {
                this.item = {
                    name: '', nameEn: '', itemOrder: '', title: '', titleEn: '',
                    description: '', descriptionEn: '', category: {}, images: [], image360: {},
                    thumbnail: {}, datasheet: {}, features: [], additionalServices: [],
                    summary: '', summaryEn: '', url: '', canBuy: false,
                    tags: [], equipment: [], equipmentEn: [], additionalEquipment: [],
                    additionalEquipmentEn: [], attributes: {}, attributesEn: {}
                }
            }
        },
        methods: {
            trimEllip(s, length) { return s.length > length ? s.substring(0, length) + "..." : s; },
            cancel() { this.$router.push('/products') },
            getTagVariant(val) {
                let tag = this.availableTags.find(t => t.value === val);
                return tag && tag.variant ? tag.variant : 'primary';
            },
            getTagLabel(val) {
                let tag = this.availableTags.find(t => t.value === val);
                return tag ? tag.text : val;
            },
            getTagClass(val) {
                let tag = this.availableTags.find(t => t.value === val);
                return tag && tag.customClass ? tag.customClass : 'tag-custom-default';
            },
            addEquipmentRow() { this.newEquipment.push({ name: '', nameEn: '' }) },
            deleteEquipmentRow(index) { this.newEquipment.splice(index, 1) },

            addAdditionalEquipmentRow() { this.newAdditionalEquipment.push({ name: '', nameEn: '' }) },
            deleteAdditionalEquipmentRow(index) { this.newAdditionalEquipment.splice(index, 1) },

            addAttributeRow() { this.newAttributes.push({ key: '', value: '', keyEn: '', valueEn: '' }) },
            deleteAttributeRow(index) { this.newAttributes.splice(index, 1) },

            addApplicationRow() { this.newApplications.push({ name: '', nameEn: '' }) },
            deleteApplicationRow(index) { this.newApplications.splice(index, 1) },

            addAdvantageRow() { this.newAdvantages.push({ name: '', nameEn: '' }) },
            deleteAdvantageRow(index) { this.newAdvantages.splice(index, 1) },

            addFaqRow() { this.newFaq.push({ question: '', answer: '', questionEn: '', answerEn: '' }) },
            deleteFaqRow(index) { this.newFaq.splice(index, 1) },

            saveItem() {
                var app = this
                let eqPlOut = [];
                let eqEnOut = [];
                this.newEquipment.forEach(e => {
                    if (e.name || e.nameEn) {
                        eqPlOut.push(e.name || '');
                        eqEnOut.push(e.nameEn || '');
                    }
                });


                let aeqPlOut = [];
                let aeqEnOut = [];
                this.newAdditionalEquipment.forEach(e => {
                    if (e.name || e.nameEn) {
                        aeqPlOut.push(e.name || '');
                        aeqEnOut.push(e.nameEn || '');
                    }
                });

                let attrPlOut = {};
                let attrEnOut = {};
                this.newAttributes.forEach(a => {
                    if (a.key) attrPlOut[a.key] = a.value || '';
                    if (a.keyEn) attrEnOut[a.keyEn] = a.valueEn || '';
                });

                let appPlOut = []; let appEnOut = [];
                this.newApplications.forEach(a => {
                    if (a.name || a.nameEn) { appPlOut.push(a.name || ''); appEnOut.push(a.nameEn || ''); }
                });

                let advPlOut = []; let advEnOut = [];
                this.newAdvantages.forEach(a => {
                    if (a.name || a.nameEn) { advPlOut.push(a.name || ''); advEnOut.push(a.nameEn || ''); }
                });

                let faqPlOut = {}; let faqEnOut = {};
                this.newFaq.forEach(f => {
                    if (f.question) faqPlOut[f.question] = f.answer || '';
                    if (f.questionEn) faqEnOut[f.questionEn] = f.answerEn || '';
                });

                axios.post(Const.API_HOST + '/admin/productItem/save', {
                    productItem: {
                        id: this.item.id,
                        name: this.item.name,
                        nameEn: this.item.nameEn,
                        itemOrder: this.item.itemOrder,
                        title: this.item.title,
                        titleEn: this.item.titleEn,
                        description: this.item.description,
                        descriptionEn: this.item.descriptionEn,
                        category: this.item.category,
                        images: this.item.images,
                        image360: this.item.image360,
                        thumbnail: this.item.thumbnail,
                        datasheet: this.item.datasheet,
                        features: this.newFeatures,
                        summary: this.item.summary,
                        summaryEn: this.item.summaryEn,
                        url: this.item.url,
                        canBuy: this.item.canBuy,
                        additionalServices: this.newAS,
                        tags: this.newTags,
                        equipment: eqPlOut,
                        equipmentEn: eqEnOut,
                        additionalEquipment: aeqPlOut,
                        additionalEquipmentEn: aeqEnOut,
                        attributes: attrPlOut,
                        attributesEn: attrEnOut,
                        applications: appPlOut,
                        applicationsEn: appEnOut,
                        advantages: advPlOut,
                        advantagesEn: advEnOut,
                        faq: faqPlOut,
                        faqEn: faqEnOut
                    }
                }).then(function (response) {
                    if (response.status === 200) { app.$router.push('/products') }
                    // eslint-disable-next-line no-console
                }).catch(function (error) { console.error(error) })
            },
            deleteItem() {
                var app = this
                axios.delete(Const.API_HOST + '/admin/productItem/delete', { data: { id: this.item.id } })
                    .then(function (response) {
                        if (response.status === 200) { app.$router.push('/products') }
                        // eslint-disable-next-line no-console
                    }).catch(function (error) { console.error(error) })
            },
            openImagePicker(context) {
                this.imagePickerContext = context;
                this.resetImagePicker();
                this.$bvModal.show('image-picker')
                axios.get(Const.API_HOST + '/admin/images')
                    .then(response => response.data).then(body => {
                    this.images = body
                }).catch(error => {
                    // eslint-disable-next-line no-console
                    console.error(error)
                })
            },
            resetImagePicker() {
                this.imageSearchQuery = '';
                this.currentPage = 1;
            },
            pasteImage(id) {
                const selected = this.images.find(obj => {
                    return obj.id === id
                });

                if (this.imagePickerContext === 'thumbnail-input') {
                    this.item.thumbnail = JSON.parse(JSON.stringify(selected))
                } else if (this.imagePickerContext === 'image360-input') {
                    this.item.image360 = JSON.parse(JSON.stringify(selected))
                } else if (this.imagePickerContext === 'images-input') {
                    if (!this.item.images) {
                        this.$set(this.item, 'images', []);
                    }

                    const alreadyExists = this.item.images.find(img => img.id === selected.id);
                    if (!alreadyExists) {
                        this.item.images.push(JSON.parse(JSON.stringify(selected)));
                    }
                }

                this.$bvModal.hide('image-picker')
            },
            removeImage(index) {
                this.item.images.splice(index, 1);
            },
            removeThumbnail() {
                this.item.thumbnail = {};
            },
            removeImage360() {
                this.item.image360 = {};
            },
            openFilePicker(context) {
                this.filePickerContext = context
                this.$bvModal.show('file-picker')
                axios.get(Const.API_HOST + '/admin/files')
                    .then(response => response.data).then(body => {
                    this.files = body
                }).catch(error => {
                    // eslint-disable-next-line no-console
                    console.error(error)
                })
            },
            pasteFile(item) {
                if (this.filePickerContext === 'datasheet-input') {
                    this.item.datasheet = JSON.parse(JSON.stringify(item))
                }

                this.$bvModal.hide('file-picker')
                this.files = []
            },
            addAdditionalServiceRow() {
                let index = this.newAS.length + 1;
                this.newAS.push({ name: '', nameEn: '', serviceType: 'RECURRING_FEE', serviceOrder: index, netPrice: 0, selectedDefault: false })
            },
            deleteAdditionalServiceRow(index) {
                this.newAS.splice(index,1)
                for (let i = 0; i < this.newAS.length; i++) { this.newAS[i].serviceOrder = i+1; }
            },
            addFeatureRow() { this.newFeatures.push({ name: '', nameEn: '' }) },
            deleteFeatureRow(index) { this.newFeatures.splice(index,1) },
            nameInputValidation(index) {
                if (!this.newAS || !this.newAS[index]) return false;
                let val = this.newAS[index].name;
                return !(!val || String(val).trim().length <= 5);
            },
            nameEnInputValidation(index) {
                if (!this.newAS || !this.newAS[index]) return false;
                let val = this.newAS[index].nameEn;
                return !(!val || String(val).trim().length <= 5);
            },
            featureNameInputValidation(index) {
                if (!this.newFeatures || !this.newFeatures[index]) return false;
                let val = this.newFeatures[index].name;
                return !(!val || String(val).trim().length <= 5);
            },
            featureNameEnInputValidation(index) {
                if (!this.newFeatures || !this.newFeatures[index]) return false;
                let val = this.newFeatures[index].nameEn;
                return !(!val || String(val).trim().length <= 5);
            },
            netPriceValidation(index) {
                if (!this.newAS || !this.newAS[index]) return false;
                let val = this.newAS[index].netPrice;
                // Sprawdzamy, czy wartość istnieje, czy nie jest pustym stringiem (co input type="number" po usunięciu może zwrócić) i czy jest liczbą > 0
                return val !== null && val !== undefined && val !== '' && !isNaN(val) && Number(val) >= 0;
            },
            serviceOrderValidation(index) {
                if (!this.newAS || !this.newAS[index]) return false;
                let val = this.newAS[index].serviceOrder;
                return val !== null && val !== undefined && val !== '' && !isNaN(val) && Number(val) > 0;
            },
        }
    }
</script>

<style scoped>
    .clickable /deep/ tbody td {
        cursor: pointer;
    }

    .browser-image {
        max-width: 100%;
        max-height: 100%;
        cursor: pointer;
    }

    /deep/ .tox-editor-container div:first-child {
        top: 58px !important;
    }

    .image-tile {
        width: 140px;
        height: 140px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .add-image-tile {
        border: 2px dashed #adb5bd !important;
        background-color: #f8f9fa;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
    }

    .add-image-tile:hover {
        background-color: #e9ecef;
        border-color: #007bff !important;
        color: #007bff !important;
    }

    .add-image-tile .add-icon {
        font-size: 3.5rem;
        font-weight: 300;
        line-height: 1;
        color: #adb5bd;
        transition: color 0.2s ease-in-out;
        user-select: none;
    }

    .add-image-tile:hover .add-icon {
        color: #007bff;
    }

    .image-grid-container {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
        gap: 15px;
        padding: 5px;
    }

    .image-picker-tile {
        cursor: pointer;
        overflow: hidden;
        transition: all 0.2s ease-in-out;
        background-color: #fff;
        display: flex;
        flex-direction: column;
    }

    .image-picker-tile:hover {
        box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
        border-color: #007bff !important;
        transform: translateY(-2px);
    }

    .image-thumbnail-wrapper {
        height: 100px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px;
    }

    .image-thumbnail-wrapper img {
        max-height: 100%;
        max-width: 100%;
        object-fit: contain;
    }

    .image-tile-footer {
        border-top: 1px solid #dee2e6;
        font-size: 0.75rem;
    }

    ::v-deep .tag-custom-green {
        background-color: #4da661 !important;
        color: #ffffff !important;
        border-radius: 4px;
    }

    ::v-deep .tag-custom-pink {
        background-color: #ef476f !important;
        color: #ffffff !important;
        border-radius: 4px;
    }

    ::v-deep .tag-custom-orange {
        background-color: #f77f00 !important;
        color: #ffffff !important;
        border-radius: 4px;
    }

    ::v-deep .tag-custom-purple {
        background-color: #118ab2 !important;
        color: #ffffff !important;
        border-radius: 4px;
    }

    ::v-deep .tag-custom-default {
        background-color: #6c757d !important;
        color: #ffffff !important;
        border-radius: 4px;
    }

    ::v-deep .b-form-tag > button.b-form-tag-remove {
        color: #ffffff !important;
        opacity: 0.8;
        font-size: 1rem;
        margin-left: 6px;
    }
    ::v-deep .b-form-tag > button.b-form-tag-remove:hover {
        opacity: 1;
    }

    .shadow-top-lg {
        -webkit-box-shadow: 0 -1rem 1rem -1rem rgba(0, 0, 0, 0.175) !important;
        box-shadow: 0 -1rem 1rem -1rem rgba(0, 0, 0, 0.175) !important;
    }
</style>
